import Enum from "@/enums/Enum";
import BaseEnum from "@/enums/BaseEnum";
/**
 * 総合判定
 */
export default class SogoHantei extends BaseEnum{
    static RYKO = {value: '0', name: '良好', color: '#8CC545'} as SogoHanteiEnum
    static CHUI = {value: '1', name: '注意', color: '#EFAC3F'} as SogoHanteiEnum
    static YOCHIRYO = {value: '2', name: '要治療', color: '#E56741'} as SogoHanteiEnum
    static HANTEI_HUKA = {value: 'null', name: '判定不可', color: 'gray'} as SogoHanteiEnum
    static HANTEI_HUKA_EMPTY = {value: '', name: '判定不可', color: 'gray'} as SogoHanteiEnum
}
export interface SogoHanteiEnum extends Enum{
	color: string
}
SogoHantei.values = [SogoHantei.RYKO, SogoHantei.CHUI, SogoHantei.YOCHIRYO, SogoHantei.HANTEI_HUKA, SogoHantei.HANTEI_HUKA_EMPTY]
